import {
  animate,
  animateChild,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    imports: [NgIf, NgFor],
    styleUrls: ['./carousel.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({ opacity: 1 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate(300),
                query('@*', animateChild(), { optional: true }),
            ]),
            transition(':leave', [
                animate(300, style({ opacity: 0 })),
                query('@*', animateChild(), { optional: true }),
            ]),
            transition('* <=> *', [
                animate(300, style({ opacity: 0 })),
                query('@*', animateChild(), { optional: true }),
            ]),
        ]),
    ]
})
export class CarouselComponent implements OnChanges {
  @ViewChild('slider') slider!: ElementRef;
  @Input() options: any;
  @Input() select?: number;
  indicators: any[] = new Array(1);
  option: any;
  insufficientSlides: boolean = true;
  less = false;
  more = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private ref: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.select?.currentValue && !changes?.select?.firstChange) {
      this.slideTo(changes.select.currentValue);
    } else {
      this.ref.nativeElement.style.setProperty('--slides', '100%');
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.resize();
          setTimeout(() => {
            this.slider.nativeElement.scrollLeft = 0;
          }, 60);
        }, 45);
      }
    }
  }

  moreOrLess() {
    this.less =
      !this.insufficientSlides &&
      Math.floor(this.slider.nativeElement.scrollLeft).toFixed(0) != '0';
    this.more =
      !this.insufficientSlides &&
      Math.floor(this.slider.nativeElement.scrollWidth) !=
        Math.floor(
          this.slider.nativeElement.scrollLeft +
            this.slider.nativeElement.offsetWidth
        );
  }

  @HostListener('window:scroll')
  scroll() {
    this.moreOrLess();
  }

  @HostListener('window:resize')
  resize() {
    this.selectOptionsForBreakpoint();
    this.ref.nativeElement.style.setProperty(
      '--slides',
      100 / this.option.slides + '%'
    );
    try {
      this.insufficientSlides =
        this.slider.nativeElement.children.length <= this.option.slides;
      if (this.insufficientSlides == true) {
        this.less = false;
        this.more = false;
      } else {
        this.moreOrLess();
      }
      this.more = true;
    } catch {}
  }

  selectOptionsForBreakpoint() {
    let length = Object.keys(this.options).length;
    if (length == 0) {
      this.option = { 0: { slides: 1, nav: true, dots: true } };
      return;
    }
    if (length == 1) {
      this.option = this.options[0];
      return;
    }
    for (let entry of Object.keys(this.options)) {
      let check = parseInt(entry);
      if (window.innerWidth > check) {
        this.option = this.options[entry];
        continue;
      } else {
        return;
      }
    }
  }

  slideTo(i: number) {
    const left =
      (this.slider.nativeElement.getBoundingClientRect().width /
        this.option.slides) *
      i;
    smoothScroll(this.slider.nativeElement, left).then((data) => {
      this.moreOrLess();
    });
  }

  slide(direction: 'prev' | 'next') {
    let left;
    const { scrollLeft } = this.slider.nativeElement;
    const width =
      this.slider.nativeElement.getBoundingClientRect().width /
      this.option.slides;
    switch (direction) {
      case 'prev':
        left = scrollLeft - width;
        break;
      case 'next':
      default:
        left = scrollLeft + width;
        break;
    }
    this.moreOrLess();

    smoothScroll(this.slider.nativeElement, left).then((data) => {
      this.moreOrLess();
    });
  }
}

function smoothScroll(elem: any, left: number) {
  elem.scrollTo({
    left: left,
    behavior: 'smooth',
  });

  return new Promise((resolve, reject) => {
    const failed = setTimeout(() => {
      reject();
    }, 2000);
    const scrollHandler = () => {
      if (Math.floor(elem.scrollLeft) === Math.floor(left)) {
        elem.removeEventListener('scroll', scrollHandler);
        clearTimeout(failed);
        resolve(true);
      }
    };
    if (Math.floor(elem.scrollLeft) === Math.floor(left)) {
      clearTimeout(failed);
      resolve(true);
    } else {
      elem.addEventListener('scroll', scrollHandler);
    }
  });
}
